module.exports = {
  "country": "IL",
  "artist": "Netta",
  "song": "Toy",
  "year": "2018",
  "place": "1",
  "spotify": "6VO6JrvcuGMfPOQgT6kSGE"
};